export default __webpack_public_path__ + "static/media/hedwig-step-1.8996398b.png";